<script setup>

import {computed} from "vue";

const props = defineProps({
    variant: Object,
    selectedProduct: Object,
});

const priceDiff = computed(() => {
    return (props.variant.price_including_vat - props.selectedProduct.price_including_vat) / 100
});
</script>

<template>
    <div
        class="flex flex-col font-medium text-gray-900 sm:flex-row sm:gap-1"
    >
        <div>
            {{ variant.variant_label }}
        </div>

        <div v-if="priceDiff !== 0 ">
            ( {{ priceDiff > 0 ? '+' : '-' }} € {{ priceDiff.toFixed(2).replace('.', ',') }} )
        </div>
    </div>
</template>
